export const scheduleSessionTypes = ["COUNSELING", "ASSESSMENT"] as const;
export const scheduleTypes = ["Offline", "Online"] as const;